import { render } from "./WelcomePage.vue?vue&type=template&id=5bbcd9e2&ts=true"
import script from "./WelcomePage.vue?vue&type=script&lang=ts"
export * from "./WelcomePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__